<template>
  <layout-main-inner title="首页设置">
    <div slot="action">
      <el-button
        v-if="$route.query.portalPageId"
        type="primary"
        :loading="loading"
        @click="edit">更新</el-button>
      <el-button
        v-else
        type="primary"
        :loading="loading"
        @click="edit">保存</el-button>
    </div>
    <layout-card-wrap v-loading="loading">
      <div class="page-wrap">
        <div class="weapp-phone">
          <!-- app navibar -->
          <div
            class="series-item-wrap"
            :class="{ active: headers.visible }"
            @click="() => { toggle('headers'); }">
            <we-header-view :templateId="1" />
          </div>
          <div style="background-color:#F7F7F7;height: 560px;overflow-y: scroll;overflow-x:hidden;">
            <draggable
              v-if="seriesList.length"
              v-model="seriesList"
              :options="dragOptions">
              <template v-for="(item, index) in seriesList">
                <div
                  :key="index"
                  style="cursor: grab;"
                  class="series-item-wrap"
                  :class="{ active: item.visible }"
                  @click="() => { toggle(undefined, index); } ">
                  <we-series-view
                    v-if="item.componentName === 'servicecategoryshow'"
                    :list="item.graphics" />
                  <we-vendor-view
                    v-if="item.componentName === 'vendorshow'"
                    :list="item.graphics" />
                  <we-scan-view v-if="item.componentName === 'qrscan'" />
                  <we-circular-view
                    v-if="item.componentName === 'pictureadv' && item.layoutType === 0"
                    :list="item.graphics" />
                  <we-image-view
                    v-if="item.componentName === 'pictureadv' && item.layoutType !== 0"
                    :imageView="item"
                    :templateId="1" />
                </div>
              </template>
            </draggable>
          </div>
          <!-- app tab-bar -->
          <div class="series-item-wrap">
            <we-footer-view />
          </div>
          <div style="height: 20px;"></div>
          <el-button
            type="primary"
            style="margin:0px 0 10px 5px"
            @click="addSeries(5)">查询组件</el-button>
          <el-button
            type="primary"
            style="margin:0px 0 10px 5px"
            @click="addSeries(1)">服务产品</el-button>
          <el-button
            type="primary"
            style="margin:0px 0 10px 5px"
            @click="addSeries(2)">图片导航</el-button>
          <el-button
            type="primary"
            style="margin:0px 0 10px 5px"
            @click="addSeries(3)">轮播图</el-button>
          <el-button
            type="primary"
            style="margin:0px 0 10px 5px"
            @click="addSeries(4)">企业组件</el-button>
        </div>
        <div class="setting-wrap">
          <we-header
            v-show="headers.visible"
            ref="header"
            v-model="headers" />
          <template v-for="(item, index) in seriesList">
            <template
              v-if="item.componentName === 'pictureadv' && item.layoutType === 0 ">
              <we-circular
                v-show="item.visible"
                :ref="'series_' + index"
                :key="index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template v-if="item.componentName === 'servicecategoryshow'">
              <we-series
                v-show="item.visible"
                :key="index"
                :ref="'series_' + index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template v-if="item.componentName === 'vendorshow'">
              <we-vendor
                v-show="item.visible"
                :key="index"
                :ref="'series_' + index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template v-if="item.componentName === 'qrscan'">
              <we-scan
                v-show="item.visible"
                :key="index"
                :ref="'series_' + index"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template
              v-if=" item.componentName === 'pictureadv' && item.layoutType !== 0 && item.layoutType !== 20">
              <we-image
                v-show="item.visible"
                :ref="'series_' + index"
                :key="index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
          </template>
        </div>
      </div>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import './busi/index.styl'
import WeHeader from './busi/we-header.vue'
import WeHeaderView from './busi/we-header-view.vue'
import WeCircular from './busi/we-circular.vue'
import WeCircularView from './busi/we-circular-view.vue'
import WeImage from './busi/we-image.vue'
import WeImageView from './busi/we-image-view.vue'
import WeSeries from './busi/we-series.vue'
import WeSeriesView from './busi/we-series-view.vue'
import WeFooterView from './busi/we-footer-view.vue'
import draggable from 'vuedraggable'
import WeVendorView from './busi/we-vendor-view.vue'
import WeVendor from './busi/we-vendor.vue'
import WeScan from './busi/we-scan.vue'
import WeScanView from './busi/we-scan-view.vue'
export default {
  name: 'GatewayEdit', // WeHeader, WeCircular, WeActivity,WeDiscount, WeSeries,WeActivityView, WeDiscountView,
  components: { WeScan, WeScanView, WeVendorView, WeVendor, WeCircularView, WeHeaderView, WeSeriesView, WeFooterView, WeImageView, WeImage, WeHeader, WeCircular, WeSeries, draggable },
  props: {},
  data() {
    return {
      loading: false,
      dragOptions: { animation: 0, disabled: false, group: 'description', ghostClass: 'ghost' },
      headers: { visible: false, pageName: '', pageTitle: '', status: 0 },
      seriesList: []
    }
  },
  mounted() {
    console.log(this.$route.query)
    this.vendorId = this.$route.query.vendorId
    if (this.$route.query.portalPageId) {
      this.portalPageId = this.$route.query.portalPageId
      this.getportalpage()
    }
    this.toggle('headers')
  },
  methods: {
    deleteItem(index) {
      this.seriesList.splice(index, 1)
    },
    toggle(ref, index) {
      if (index !== undefined) {
        this.headers.visible = false
        this.seriesList.forEach((i, idx) => {
          i.visible = idx === index
        })
      } else {
        this.headers.visible = false
        this.seriesList.forEach(i => {
          i.visible = false
        })
        this[ref].visible = true
      }
    },
    addSeries(type) {
      if (type === 1) { // 服务组件
        this.seriesList.push({ componentName: 'servicecategoryshow', layoutType: 1, graphics: [], visible: false })
      }
      if (type === 2) { // 图片组件
        this.seriesList.push({ componentName: 'pictureadv', layoutType: 1, graphics: [], visible: false })
      }
      if (type === 3) { // 轮播图
        this.seriesList.push({ componentName: 'pictureadv', layoutType: 0, graphics: [], styleType: 1, visible: false })
      }
      if (type === 4) { // 企业组件
        this.seriesList.push({ componentName: 'vendorshow', layoutType: 1, graphics: [], visible: false })
      }
      if (type === 5) { // 查询入口组件
        this.seriesList.push({ componentName: 'qrscan', visible: false })
      }
    },
    edit() {
      const submitList = [this.$refs.header.submit()]
      this.seriesList.forEach((i, idx) => {
        const ref = 'series_' + idx
        submitList.push(this.$refs[ref][0].submit())
      })
      Promise.all(submitList)
        .then(() => {
          const list = this.seriesList.map(i => {
            if (i.componentName === 'pictureadv') {
              return {
                componentName: 'pictureadv',
                data: {
                  layoutType: i.layoutType,
                  styleType: i.styleType,
                  graphics: i.graphics.map(s => {
                    const image = s.image.map(img => img.url).join(',')
                    return { ...s, image }
                  })
                }
              }
            }
            if (i.componentName === 'servicecategoryshow') {
              return {
                componentName: i.componentName,
                data: {
                  layoutType: i.layoutType,
                  data: i.graphics.map(s => ({ serviceCategoryId: s.serviceCategoryId }))
                }
              }
            }
            if (i.componentName === 'vendorshow') {
              return {
                componentName: i.componentName,
                data: {
                  vendors: i.graphics.map(s => ({ vendorId: s.vendorId }))
                }
              }
            }
            return i
          })
          const headers = this.headers
          const postData = {
            pageName: headers.pageName,
            pageTitle: headers.pageTitle,
            status: headers.status,
            portalPageId: this.portalPageId || null,
            wxappPageId: this.wxappPageId || null,
            vendorId: this.vendorId,
            vBody: [...list]
          }
          console.log(postData)
          this.loading = true
          const dispatch = this.portalPageId ? 'updateportalpage' : 'addportalpage'
          this.$store.dispatch(`gateway/${dispatch}`, {
            payload: { ...postData },
            success: () => {
              this.loading = false
              this.$message.success('更新成功')
            },
            fail: () => {
              this.loading = false
            }
          })
        })
        .catch(err => {
          console.log(err)
          const error = JSON.parse(err.message)
          if (error.pop) {
            this.toggle(error.pop)
          }
          if (Number.isInteger(error.index)) {
            this.toggle(undefined, error.index)
          }
        })
    },
    getportalpage() {
      this.loading = true
      this.$store.dispatch('gateway/getportalpage', {
        payload: { vendorId: this.vendorId, portalPageId: this.portalPageId },
        success: res => {
          this.loading = false
          const data = res.data
          this.wxappPageId = data.wxappPageId
          this.headers = { ...this.headers, pageName: data.pageName, pageTitle: data.pageTitle, status: data.status }
          const list = data.vBody.map(i => {
            if (i.componentName === 'pictureadv') {
              return {
                visible: false,
                componentName: 'pictureadv',
                layoutType: i.data.layoutType,
                styleType: i.data.styleType,
                graphics: i.data.graphics.map(s => {
                  const image = s.image.split(',').map(url => ({ url }))
                  return { ...s, image }
                })
              }
            }
            if (i.componentName === 'servicecategoryshow') {
              return { visible: false, componentName: i.componentName, layoutType: i.data.layoutType, graphics: i.data.data }
            }
            if (i.componentName === 'vendorshow') {
              return { visible: false, componentName: i.componentName, graphics: i.data.vendors }
            }
            return i
          })
          this.seriesList.push(...list)
          setTimeout(() => {
            this.toggle('headers')
          }, 20)
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.page-wrap {
  display: flex;
}

.setting-wrap {
  flex: 1;
  padding-left: 24px;
}

.weapp-phone {
  flex: 0 0 375px;
  width: 375px;
  border: 1px solid #f0f2f5;

  img {
    width: 100%;
    display: inline-block;
    vertical-align: top;
  }

  .active {
    position: relative;

    &::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      top: -50%;
      right: -50%;
      bottom: -50%;
      left: -50%;
      border: 2px dashed red;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
  }

  .series-item-wrap {
    position: relative;
  }

  .series-item-wrap + .series-item-wrap {
    margin-top: 5px;
  }
}
</style>
